import { render, staticRenderFns } from "./CompanyDiscounts.vue?vue&type=template&id=95e91228"
import script from "./CompanyDiscounts.vue?vue&type=script&lang=js"
export * from "./CompanyDiscounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports